export default __webpack_public_path__ + "static/media/img6.e3ceff63.PNG";